// extracted by mini-css-extract-plugin
export default {"container":"qvpH9o","title":"iWkEjf","description":"j04qiR","descriptionText":"NN8r7d"};